var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAichat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 18.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.07,16.56H5.14c-.92,0-1.67-.75-1.67-1.67v-.98c0-.92.75-1.67,1.67-1.67h11.92c.92,0,1.67.75,1.67,1.67v.98c0,.92-.75,1.67-1.67,1.67ZM5.14,13.24c-.37,0-.67.3-.67.67v.98c0,.37.3.67.67.67h11.92c.37,0,.67-.3.67-.67v-.98c0-.37-.3-.67-.67-.67H5.14Z",
    fill: "#4d4d4d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25,18.5H1.82c-1,0-1.82-.82-1.82-1.82V1.82C0,.82.82,0,1.82,0h18.43c1,0,1.82.82,1.82,1.82v14.86c0,1-.82,1.82-1.82,1.82ZM1.82.95c-.48,0-.87.39-.87.87v14.86c0,.48.39.87.87.87h18.43c.48,0,.87-.39.87-.87V1.82c0-.48-.39-.87-.87-.87H1.82Z",
    fill: "#4d4d4d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.17,3.57H3.48c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h7.69c.28,0,.5.22.5.5s-.22.5-.5.5Z",
    fill: "#4d4d4d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.17,6.11H3.48c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h7.69c.28,0,.5.22.5.5s-.22.5-.5.5Z",
    fill: "#4d4d4d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.19,8.32h-7.69c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h7.69c.28,0,.5.22.5.5s-.22.5-.5.5Z",
    fill: "#4d4d4d"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.19,10.77h-7.69c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h7.69c.28,0,.5.22.5.5s-.22.5-.5.5Z",
    fill: "#4d4d4d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAichat);
export default __webpack_public_path__ + "static/media/aichat.8673bb87c1a5ec9c1ed0f55ef69802e6.svg";
export { ForwardRef as ReactComponent };